import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Searchbar } from 'app/components';
import { card } from './data';
import Banner from '../banner';
import { getEventById } from '../../api';

const SubStep1 = ({ updateStep, updateSubStep, setError }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.fbq("trackCustom", "StartResellFlow");
  }, []);

  const handleEventSelect = (id) => {
    getEventById(id, () => {
      updateSubStep(2);
      setError({});
    });
  };

  const handleBack = () => {
    updateStep(1);
    updateSubStep(1);
  };

  return (
    <div className="flex flex-col gap-6 mt-9 h-full">
      <Helmet>
        <title>Sell tickets</title>
        <meta
          name="title"
          content="Sell Tickets Easily in India | Reach Your Audience on Take My Tickets"
        />
        <meta
          name="description"
          content="Start selling your event tickets hassle-free on Take My Tickets, India's trusted ticket resale platform. Add seller contact details effortlessly."
        />
        <meta charset="UTF-8" />
      </Helmet>
      <h1 className="font-[600] text-[24px] text-start text-[#101010] lg:text-[36px]">
        Sell your tickets quickly
      </h1>
      <div className="label-1 flex flex-col gap-2">
        {window.innerWidth > 650 ? (
          <Searchbar
            width="100%"
            height="316px"
            onSelect={handleEventSelect}
            label="Which event are you selling tickets for?"
            onClickBack={handleBack}
            filter={(eventConfig) => !eventConfig?.disallow_ticket_selling}
            resale={true}
          />
        ) : (
          <Searchbar
            type="mobile"
            width="100%"
            height="80vh"
            onSelect={handleEventSelect}
            label="Which event are you selling tickets for?"
            onClickBack={handleBack}
            filter={(eventConfig) => !eventConfig?.disallow_ticket_selling}
            resale={true}
          />
        )}
        <div className="label-14 text-black pb-1 pt-2">
          Sell your tickets in 3 steps:
        </div>
        <div className="flex flex-col gap-3 px-1">
          {card.map((item, index) => (
            <div
              key={index}
              className="label-14 text-black gap-3 flex items-center"
            >
              {item.icon}
              {item.content}
            </div>
          ))}
        </div>
      </div>
      <Banner />
    </div>
  );
};

export default SubStep1;
